import { Layout } from "antd";
import { LocalContext } from "context/AuthenticationContext";
import { ContextType, PureComponent, ReactNode } from "react";
import { productCache } from "utils/cache/productCache";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { ProviderCodeEnum } from "utils/enums/ProviderCodeEnum";
const { Footer: AntFooter } = Layout;

export default class Footer extends PureComponent {
  static contextType = LocalContext;
  context!: ContextType<typeof LocalContext>;

  private get partnerInfo() {
    return productCache?.getCache(CacheKeyEnum.partnerOfUser);
  }

  render(): ReactNode {
    const { versionNumber } = this.context;
    const isNeciProvider =
      this.partnerInfo &&
      this.partnerInfo[0]?.providerCode === ProviderCodeEnum.neci;

    return (
      <AntFooter className="2xl:text-[14px] text-[11px] w-full mt-auto bg-white lg:text-left text-center">
        <p>
          {" "}
          Copyright © 2026 by{" "}
          <a
            target="_blank"
            className="hover:text-blue-600 font-[700] hover:underline"
            href={"https://phuongquan.vn/introduce"}
            rel="noreferrer"
          >
            {"Phuong Quan"}
          </a>
          <span className="ml-1">(Version {versionNumber})</span>
        </p>
      </AntFooter>
    );
  }
}
